export function sanitizePaymentServiceErrorMessage(
  message: unknown,
  fallback = 'Payment service request failed',
): string {
  const text = typeof message === 'string' && message.trim() ? message : fallback;
  return text
    .replace(/\bhttps?:\/\/(?:[\w-]+\.)*tilled\.com\b/gi, 'payment service')
    .replace(/\b(?:[\w-]+\.)*tilled\.com\b/gi, 'payment service')
    .replace(/tilled/gi, 'payment service');
}

export function sanitizePaymentServiceError<T>(error: T): T {
  if (!error || typeof error !== 'object' || Array.isArray(error)) {
    return error;
  }

  const record = error as Record<string, unknown>;
  if (!('message' in record)) {
    return error;
  }

  return {
    ...record,
    message: sanitizePaymentServiceErrorMessage(record.message),
  } as T;
}
